   // src/main.js
   import Vue from 'vue';
   import App from './App.vue';
   import router from './router';

   // 引入 Bootstrap 依赖
   import 'jquery';
   import 'popper.js';
   import 'bootstrap';
   import 'bootstrap/dist/css/bootstrap.min.css';

   // 引入主样式文件
   import './assets/styles/main.css';
   import './assets/styles/video.css';
   import './assets/styles/video-fullscreen.css';
   import './assets/styles/announcement.css';

   Vue.config.productionTip = false;

   new Vue({
     router,
     render: h => h(App),
   }).$mount('#app');